import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-groups-list',
  standalone: false,
  templateUrl: './groups-list.component.html',
  styleUrls: ['./groups-list.component.css']
})
export class GroupsListComponent implements OnInit {
  groups: any[] = [];

  constructor(private admin: AdminService, private router: Router) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.admin.getGroups().subscribe(
      g => this.groups = this.unwrap(g),
      () => notify('Unable to load groups', 'error', 2500)
    );
  }

  private unwrap(res: any): any[] {
    return Array.isArray(res) ? res : (res?.data ?? []);
  }

  onToolbarPreparing(e: any): void {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: { icon: 'plus', text: 'Add Group', type: 'default', onClick: () => this.router.navigate(['/admin/groups/new']) }
    });
  }

  onEditClick = (e: any): void => { this.router.navigate(['/admin/groups', e.row.data.id]); };

  onDeleteClick = (e: any): void => {
    const group = e.row.data;
    confirm(`Delete group "${group.name}"? This cannot be undone.`, 'Confirm delete').then(ok => {
      if (!ok) { return; }
      this.admin.deleteGroup(group.id).subscribe(() => {
        notify('Group deleted', 'success', 2000);
        this.load();
      }, err => notify(err?.error?.message || 'Unable to delete group', 'error', 2500));
    });
  };
}
